import {
  Timestamp,
  arrayUnion,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { v4 as uuid } from "uuid";
import { customOrderByDESC } from "./helper";

const parsePayload = (payload) => {
  return JSON.parse(JSON.stringify(payload));
};

export const getAllPayProjectsGroupInRealTime = (communityCode, cb) => {
  return onSnapshot(
    query(collection(db, "pay_project_group"), where("communityCode", "==", communityCode)),
    (doc) => {
      const dataSnaps = [];
      doc.forEach((each) => {
        const temp = each.data();
        const object = {
          ...temp,
          temp: temp.timestamp.seconds,
        };
        dataSnaps.push(object);
      });
      cb(customOrderByDESC(dataSnaps));
    }
  );
};

export const getPayProjectsGroupInfoByPayId = async (communityCode, payId, cb) => {
  const doc = await getDocs(
    query(collection(db, "pay_project_group"), where("communityCode", "==", communityCode),
      where("payId", "==", payId))
  );
  const dataSnaps = [];
  doc.forEach((each) => {
    const temp = each.data();
    const object = {
      ...temp,
      temp: temp.timestamp.seconds,
    };
    dataSnaps.push(object);
  });
  cb(customOrderByDESC(dataSnaps));
};

export const deletePayProjectsGroup = (id) => {
  return deleteDoc(doc(db, "pay_project_group", id))
}

export const savePayProjectGroup = (id, communityCode, reqPayload) => {
  const payload = {
    id,
    communityCode,
    ...reqPayload,
    timestamp: Timestamp.now(),
  };
  return setDoc(doc(db, "pay_project_group", id), parsePayload(payload));
};
